<template>
  <div class="classStudy">
    <el-card>
      <div class="classStudy-header">
        <el-cascader
          clearable
          v-model="courseIds"
          :show-all-levels="false"
          :props="subjectTreeProps"
          placeholder="请输入所属科目"
          :options="subjectTreeList"
        ></el-cascader>
        <el-button type="primary" class="classStudy-button"  @click="addFormVisible=true"  icon="el-icon-plus">添加模考</el-button>
      </div>
    </el-card>
    <el-card class="box-card">
      <div class="classStudy-table">
        <el-table
          ref="multipleTable"
          :data="studyList.records"
          style="width: 100%;"
          row-key="id"
          border
        >
          <el-table-column prop="questionTypeName" label="状态" show-overflow-tooltip></el-table-column>
          <el-table-column prop="title" show-overflow-tooltip label="所属科目"></el-table-column>
          <el-table-column prop="answer" label="试卷类型" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="answer" label="试卷名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="answer" label="总分" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="answer" label="题量" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="answer" label="时长" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="answer" label="考试开启时间" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="answer" label="操作" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next, jumper,  total, sizes"
          style="margin-top: 20px;text-align: left;"
          :total="studyList.total"
          :page-size="studyList.pageSize"
          :page-sizes="[10, 20, 30, 40]"
          :current-page="studyList.pageNumber"
          @size-change="studySizeChange"
          @current-change="studyCurrentChange"
        ></el-pagination>
      </div>
      <el-dialog title="添加部门" :visible.sync="addFormVisible" width="30%" left>
      <!-- <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules"> -->
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" >
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="模拟试卷" prop="sort">
              <el-input
                type="number"
                v-model="addForm.sort"
                placeholder="请输入显示排序"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="考试时长" prop="resource">
              <el-input
                v-model="addForm.phone"
                placeholder="请输入部门电话"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="定时开启" prop="remark">
              <el-input
                type="textarea"
                :rows="3"
                v-model="addForm.remark"
                placeholder="请输入备注"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click.stop="reset()">重 置</el-button>
        <el-button type="primary" @click.stop="addAgentRoleInfo">提 交</el-button>
      </div>
    </el-dialog>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      studyList: [],
      studySearch: {
        pageNumber: 1,
        pageSize: 10
      },
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      formLabelWidth: "80px",
      subjectTreeList: [],
      courseIds: [],
      addForm: {},
      addFormVisible: false
    };
  },
  computed: {},
  methods: {
    // 获取课程
    getSubjectTreeList() {
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    studySizeChange(pageSize) {
      this.studySearch.pageSize = pageSize;
    },
    studyCurrentChange(pageNumber) {
      this.studySearch.pageNumber = pageNumber;
    },
    addAgentRoleInfo(){},

  },
  watch: {},
  mounted() {
    this.getSubjectTreeList();
  }
};
</script>
<style scoped>
.classStudy-button{
  float: right;
}
.classStudy-table{
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/classStudy/examMode.vue